import axios from 'axios';

export default (params) => {
  return axios
    .get(`v1/user/profile/form/options`, {
      params,
    })
    .then(({ data: res }) => res.data);
};
